module.exports = require('./dist/S3PostUploader');
